import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/constant';

export const addNotificationSchema = z
  .object({
    title: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.notification.title.required)
      .min(2, VALIDATION_MESSAGES.notification.title.min)
      .max(100, VALIDATION_MESSAGES.notification.title.max),

    description: z
      .string()
      .trim()
      .nonempty(VALIDATION_MESSAGES.notification.description.required)
      .min(2, VALIDATION_MESSAGES.notification.description.min)
      .max(250, VALIDATION_MESSAGES.notification.description.max),

    targeted_user: z
      .string()
      .nonempty(VALIDATION_MESSAGES.notification.targetedUser.required),

    type: z.string().nonempty(VALIDATION_MESSAGES.notification.type.required),

    is_scheduled: z.boolean(),

    date: z.string().optional(),
    time: z.string().optional(),
  })
  .refine(
    (data) => {
      if (data.is_scheduled) {
        return !!data.date && data.date.trim().length > 0;
      }
      return true;
    },
    {
      message: VALIDATION_MESSAGES.notification.date.required,
      path: ['date'],
    }
  )
  .refine(
    (data) => {
      if (data.is_scheduled) {
        return !!data.time && data.time.trim().length > 0;
      }
      return true;
    },
    {
      message: VALIDATION_MESSAGES.notification.time.required,
      path: ['time'],
    }
  );

export type TAddNotificationFormValues = z.infer<typeof addNotificationSchema>;
